module.exports = __webpack_public_path__ + "img/plan_bg.131a94ec.png";